<template>
    <div class="similar-escorts-wrapper" v-if="showComponent">

        <hr/>

        <div class="similar-escorts-header">
            <p>{{translate.home.similarGirls}}</p>
        </div>

        <div class="row profile-block-wrap">

            <template v-for="user in similarEscorts">
                <regular-escort v-if="!isGoldUser(user)"
                                :key="'similar-' + user.id"
                                :userProp="user"
                                @onDistanceClick="onDistanceClick"
                                @onUserClick="setTrackingSearchResultType('similar'); onUserClick(user);"
                ></regular-escort>

                <premium-escort v-if="isGoldUser(user)"
                                :key="'similar-' + user.id"
                                :userProp="user"
                                @onDistanceClick="onDistanceClick"
                                @onUserClick="setTrackingSearchResultType('similar'); onUserClick(user);"
                ></premium-escort>
            </template>


        </div>
    </div>
</template>

<script>

    import RegularEscortViewComponent from "@/components/search/partials/RegularEscortViewComponent";
    import PremiumEscortViewComponent from "@/components/search/partials/PremiumEscortViewComponent";
    import userMixin from "@/components/mixins/userMixin";
    import urlMixin from "@/components/mixins/url-mixin";
    import xtrackingMixin from '@/components/mixins/xtrackingMixin';

    const data = () => {
        return {
            showNoscript: true,
            showComponent: true,
        }
    }

    function created() {
        this.hideComponentIfNoData(this.similarEscorts);
    }

    function hideComponentIfNoData(escorts) {
        this.showComponent = (_.get(escorts, 'length', false)) > 0;
    }

    function onDistanceClick() {
        this.$emit('onDistanceClick');
    }

    function onUserClick(user) {
        this.setSearchDataToLocalStorage();

        if (!_.isEqual(this.$route.fullPath, user.profile_path)) {
            this.$router.push({path: user.profile_path});
        }
    }

    export default {
        data,
        created,
        computed: {
            ...mapState(['similarEscorts', 'translate','currentUser']),
        },
        watch: {
            similarEscorts(value) {
                this.hideComponentIfNoData(value);
            }
        },
        mixins: [
            userMixin,
            urlMixin,
            xtrackingMixin,
        ],
        components: {
            'regular-escort': RegularEscortViewComponent,
            'premium-escort': PremiumEscortViewComponent,
        },
        methods: {
            hideComponentIfNoData,
            onDistanceClick,
            onUserClick,
        }
    }
</script>

